'use client';
import Image from 'next/image';
import React, { useState } from 'react';

// widthClass: the box is 120px wide unless a form (e.g. three boxes in a row in a narrow popup) says otherwise.
const ModalDropBox = ({ placeholder, onClick, isSelect, isSelectText, suffixText, widthClass = 'w-[120px]' }) => {
  return (
    <div
      onClick={onClick}
      className={`flex justify-between items-center h-[40px] px-2 ${widthClass} rounded-[6px] mt-[4px] bg-[#F2F8FF66] shadow-custom-dark-to-white cursor-pointer `}
    >
      <div className='text-[15px] text-[#6D778E] font-normal'>
        {isSelectText ? isSelectText : placeholder}
      </div>
      <div className='flex items-center gap-1'>
        <Image
          src={'/icon_dropDown.png'}
          alt='cross_img'
          width={24}
          height={24}
        />
        {suffixText && (
          <div className='text-[15px] text-[#6D778E] font-normal'>
            {suffixText}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalDropBox;
